//Constants for survey questions
export const multipleChoiceAnswers = [
  {
    value: "Great",
  },
  {
    value: "Good",
  },
  {
    value: "Okay",
  },
  {
    value: "Not So Good",
  },
];
export const surveyQuestionsConstants = {
  ADD_MULTIPLE_CHOICE_ANSWER: "ADD_MULTIPLE_CHOICE_ANSWER",
  REMOVE_MULTIPLE_CHOICE_ANSWER: "REMOVE_MULTIPLE_CHOICE_ANSWER",
  ADD_QUESTION: "ADD_QUESTION",
  GET_QUESTIONS: "GET_QUESTIONS",
  NPS_QUESTION: "How likely are you to recommend us to family and friends?",
  NPS_TEXT_QUESTION:
    "Is there anything else you'd like to share or any thoughts on how we can make improvements?",
  NPS_STAR_RANKING: "StarRankingLast",
  OBJECT: "object",
  SECONDARY_TEXTBOX: "secondaryTextBox",
  POST_ANSWERS: "POST_ANSWERS",
  GET_QUESTIONS_ARRAY: "GET_QUESTIONS_ARRAY",
  IS_ALLOWED_TO_VIEW_SURVEY: "IS_ALLOWED_TO_VIEW_SURVEY",
  GET_CUSTOMER: "GET_CUSTOMER",
  IS_SURVEY_SUBMITTED: "IS_SURVEY_SUBMITTED",
  SURVEY_SUBMITTED: "SURVEY_SUBMITTED",
  GET_RECIPIENTS: "GET_RECIPIENTS",
  UPDATE_RECIPIENTS: "UPDATE_RECIPIENTS",
  GET_RECIPIENTS_EMAILS: "GET_RECIPIENTS_EMAILS",
  SURVEY_SCREEN_SPINNER: "SURVEY_SCREEN_SPINNER",
  GET_THEME_FOR_SURVEY: "GET_THEME_FOR_SURVEY",
  GET_BRAND_DETAIL_BY_ID: "GET_BRAND_DETAIL_BY_ID",
  SURVEY_DATA: "SURVEY_DATA",
  IS_CHANGES: "IS_CHANGES",
  SURVEY_COMPLETED: "Survey - Completed",
  SURVEY_FEEDBACK_FORM: "Survey Feedback Form",
};
export const addSurveyQuestionState = {
  questionOrder: 1,
  questionTypeId: 1,
  questionText: null,
  charLimit: null,
  secondaryTextBox: null,
  surveyQuestionRecipients: [],
  starRatingTextBox: "",
  isNew: true,
  isEdit: false,
  guid: "sfds423dfs23",
};
export const addQuestionType = [
  {
    value: 1,
    label: "Star Ranking",
  },
  {
    value: 2,
    label: "Textbox",
  },
];

export const questionTypeConstants = {
  STAR_RANKING_ID: 1,
  TEXTBOX_ID: 2,
  MULTIPLE_CHOICE_ID: 3,
  TEXTBOX: "Textbox",
  STAR_RANKING: "Star Ranking",
  MULTIPLE_CHOICE: "Multiple Choice",
};
export const screenResize = "resize";

//Constant for customer survey logo background changes
export const screenWidthConstant = 425;

//Constants for next and submit button for customer survey
export const customerSurveyButtonConstants = {
  NEXT: "NEXT",
  SUBMIT: "SUBMIT",
  BACK: "BACK",
};

//Constant for customer Url
export const customerSurveyUrl = "/customer-survey/";

//Constant for adding new questions
export const questionsJson = [
  {
    questionOrder: 1,
    questionId: 85455,
    questionTypeId: "",
    questionText: "",
    charLimit: 500,
    secondaryTextBox: [],
    addedRecipientsEmails: [],
    starRatingTextBox: "",
  },
];

export const textBoxCharLimit = 500;

export const responseType = {
  POSITIVE: 1,
  NEGATIVE: 2,
  PASSIVE: 3,
};

export const npsFirstFeatureStatusEnums = {
  NONE: 0,
  PARTIAL: 1,
  FULL: 2,
};

export const responseTypeIconColors = {
  POSITIVE: "#198754",
  NEGATIVE: "#DC3545",
  PASSIVE: "#FEC700",
  DEFAULT_COLOR: "white",
};

// constant for four star rating value
export const oneStar = "1";
export const twoStar = "2";
export const threeStar = "3";
export const fourStar = "4";
export const fiveStar = "5";

export const copyStatus = {
  COPIED: "COPIED",
  COPY: "COPY",
};

export const IS_POS_QUESTION = "isPOSQuestion";
export const IS_NPS_FIRST = "isNPSFirst";

export const sentimentQuestions = [
  {
    id: 1,
    questionText: "How likely are you to recommend us to family and friends?",
    questionTypeId: 1,
    isSentimentQuestion: true,
  },
  {
    id: 2,
    questionText:
      "Is there anything else you'd like to share or any thoughts on how we can make improvements?",
    questionTypeId: 2,
  },
];

export const NPS_FIRST_QUESTION_ORDER = -1;

/** Insertion offsets when adding a question before trailing NPS / sentiment items. */
export const surveyQuestionInsertOffsets = {
  NPS_FIRST_FULL: 1, // insert before last question only
  DEFAULT: 2, // insert before last 2 questions
};

export const surveyQuestionValidation = {
  CHAR_LIMIT_MIN: 1,
  CHAR_LIMIT_MAX_SINGLE_DIGIT: 10,
  DEFAULT_TEXTBOX_CHAR_LIMIT: 500,
  FIRST_QUESTION_ORDER: 1,
  RESTRICTED_CHAR_LIMIT_KEYS: ["e", "E", "+", "-", "."],
};

export const surveyQuestionDragStyles = {
  DROP_ANIMATION_DURATION: "0.001s",
  DRAG_OVER_PADDING: "8px",
  DRAG_OVER_GRADIENT: "linear-gradient(to right, #eef2f3, #8e9eab)",
};
